import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';


@Component({
  selector: 'app-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
  styleUrls: ['./confirmation-dialog.component.scss']
})
export class ConfirmationDialogComponent implements OnInit {
  title: string;
  message: string;
  dataObject: any;

  constructor(public dialogRef: MatDialogRef<ConfirmationDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data) {
    this.title = data.title;
    this.message = data.message;
    this.dataObject = data.dataObj;
  }

  ngOnInit(): void {

    }

  onConfirm(): void {
    this.dialogRef.close({
      response:true,
      dataObj:this.dataObject
    });
  }

  onDismiss(): void {
    this.dialogRef.close({
      response:false,
      dataObj:this.dataObject
    });
  }

}
